var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_1697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 0C8.79 0 5.55 3.24 5.55 7.2C5.55 11.16 12.75 20.4 12.75 20.4C12.75 20.4 19.95 11.16 19.95 7.2C19.95 3.24 16.71 0 12.75 0ZM12.75 9.6C11.43 9.6 10.35 8.52 10.35 7.2C10.35 5.88 11.43 4.8 12.75 4.8C14.07 4.8 15.15 5.88 15.15 7.2C15.15 8.52 14.07 9.6 12.75 9.6Z",
    fill: "#12877C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.31 13.32C19.95 14.04 19.59 14.76 19.11 15.48C21.15 16.2 22.35 17.16 22.35 18C22.35 19.44 18.51 21.6 12.75 21.6C6.99 21.6 3.15 19.44 3.15 18C3.15 17.16 4.35 16.2 6.39 15.36C5.91 14.64 5.55 13.92 5.19 13.2C2.43 14.4 0.75 16.08 0.75 18C0.75 21.36 5.79 24 12.51 24C18.51 24 24.75 21.96 24.75 18C24.75 16.08 23.07 14.4 20.31 13.32Z",
    fill: "#12877C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_1697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f0934cf3aa9536de7027b1fd4a5a298b.svg";
export { ForwardRef as ReactComponent };